<script setup lang="ts">
import Card from 'primevue/card'
// No props — slots only. D-15: default body slot + optional named header slot.
</script>

<template>
  <Card>
    <template
      v-if="$slots.header"
      #header
    >
      <header class="border-b border-border px-6 py-4">
        <slot name="header" />
      </header>
    </template>
    <template #content>
      <slot />
    </template>
  </Card>
</template>
